import 'jquery';


export const getCalculators = () => {
    let data = {}
    const url = `/devcalculator/getCalculators`;
    return $.get(url, data);
}
export const getCalculator = (id) => {
    let data = {}
    const url = `/devcalculator/${id}`;
    return $.get(url, data);
}
export const getCalculatorQuestions = (id) => {
    let data = {}
    const url = `/devcalculator/${id}/getBasicData`;
    return $.get(url, data);
}
export const getCalculatorProduct = (data, id) => {
    const url = `/devcalculator/${id}/getSystems`;
    return $.post(url, data);
}
export const getCalculatorDetails = (data, id) => {
    const url = `/devcalculator/${id}/updateSystemProducts`;
    return $.post(url, data);
}
export const getCalculationData = (data, id) => {
    const url = `/devcalculator/${id}/getCalculationData`;
    return $.post(url, data);
}
export const getDiscountsData = (data, id) => {
    return $.post(`/devcalculator/${id}/gettingDiscount`, data).then(resp => {
            return resp;
        }
    );
};

export const get = (url) => {
    return $.get(url);
}

export const post = (url, data) => {
    return $.post(url, data);
}


function createPdfLink(pdfSrc, id) {

    if (window.navigator && window.navigator.msSaveOrOpenBlob) { // IE workaround
        let byteCharacters = atob(pdfSrc);
        let byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        let byteArray = new Uint8Array(byteNumbers);
        let blob = new Blob([byteArray], {type: 'application/pdf'});
        window.navigator.msSaveOrOpenBlob(blob, 'offer-' + id + '.pdf');
    } else {
        let a = document.createElement('a');
        a.href = "data:application/octet-stream;base64," + pdfSrc;
        a.target = '_blank';
        a.download = 'offer-' + id + '.pdf';
        $('body').append(a);
        a.click();
    }

}

export const getPdf = (id, data) => {
    data.previewPDF = 1;
    return $.post(`/devcalculator/${id}/gettingDiscount`, data).then(resp => {
            createPdfLink(resp.pdfData, id)
        }
    );
}
export const getColorSortingGroups = () => {
    return $.get('/public-api/color/colorSortingGroups');
}









